// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Caml_int32 = require("rescript/lib/js/caml_int32.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Selector$SmartcutsMacros = require("./Selector.bs.js");
var ListUtils$SmartcutsMacros = require("../../bs-utils/src/ListUtils.bs.js");
var RandomCss$SmartcutsMacros = require("../../bs-select/src/RandomCss.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");

function nodeAttributesForPattern(node) {
  return ArrayUtils$SmartcutsMacros.filterMap((function (param) {
                var key = param[0];
                switch (key) {
                  case "href" :
                  case "style" :
                      return ;
                  default:
                    if (key.startsWith("data-") || key.startsWith("aria-")) {
                      return ;
                    } else {
                      return key;
                    }
                }
              }), node.attributes);
}

function t_encode(v) {
  if (typeof v === "number") {
    return ["UnknownPattern"];
  } else if (v.TAG === /* SampleSizeOne */0) {
    return [
            "SampleSizeOne",
            Decco.optionToJson(Decco.intToJson, v._0)
          ];
  } else {
    return [
            "NPlusK",
            Decco.intToJson(v._0),
            Decco.intToJson(v._1)
          ];
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "NPlusK" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* NPlusK */1,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "SampleSizeOne" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.optionFromJson(Decco.intFromJson, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SampleSizeOne */0,
                      _0: v0._0
                    }
                  };
          }
          var e$2 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "UnknownPattern" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* UnknownPattern */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function initWithTwoIndexes(maybeIndex1, maybeIndex2) {
  if (maybeIndex1 !== undefined) {
    if (maybeIndex2 !== undefined && maybeIndex1 !== maybeIndex2) {
      if (maybeIndex1 < maybeIndex2) {
        return {
                TAG: /* NPlusK */1,
                _0: maybeIndex2 - maybeIndex1 | 0,
                _1: maybeIndex1
              };
      } else {
        return {
                TAG: /* NPlusK */1,
                _0: maybeIndex1 - maybeIndex2 | 0,
                _1: maybeIndex2
              };
      }
    } else {
      return {
              TAG: /* SampleSizeOne */0,
              _0: maybeIndex1
            };
    }
  } else if (maybeIndex2 !== undefined) {
    return {
            TAG: /* SampleSizeOne */0,
            _0: maybeIndex2
          };
  } else {
    return {
            TAG: /* SampleSizeOne */0,
            _0: undefined
          };
  }
}

function updateWithAdditionalSiblingIndex(maybeIndex, pattern) {
  if (typeof pattern === "number") {
    return /* UnknownPattern */0;
  }
  if (pattern.TAG !== /* SampleSizeOne */0) {
    if (maybeIndex !== undefined && Caml_int32.mod_(maybeIndex - pattern._1 | 0, pattern._0) === 0) {
      return pattern;
    } else {
      return /* UnknownPattern */0;
    }
  }
  var index = pattern._0;
  if (index !== undefined) {
    if (maybeIndex !== undefined) {
      if (index === maybeIndex) {
        return {
                TAG: /* SampleSizeOne */0,
                _0: index
              };
      } else if (index < maybeIndex) {
        return {
                TAG: /* NPlusK */1,
                _0: maybeIndex - index | 0,
                _1: index
              };
      } else {
        return {
                TAG: /* NPlusK */1,
                _0: index - maybeIndex | 0,
                _1: maybeIndex
              };
      }
    } else {
      return /* UnknownPattern */0;
    }
  } else if (maybeIndex !== undefined) {
    return {
            TAG: /* SampleSizeOne */0,
            _0: maybeIndex
          };
  } else {
    return pattern;
  }
}

function merge(pattern_1, pattern_2) {
  if (typeof pattern_1 === "number") {
    return /* UnknownPattern */0;
  }
  if (pattern_1.TAG !== /* SampleSizeOne */0 && typeof pattern_2 !== "number" && pattern_2.TAG !== /* SampleSizeOne */0) {
    return /* UnknownPattern */0;
  }
  if (typeof pattern_2 === "number") {
    return /* UnknownPattern */0;
  } else if (pattern_2.TAG === /* SampleSizeOne */0) {
    return updateWithAdditionalSiblingIndex(pattern_2._0, pattern_1);
  } else {
    return updateWithAdditionalSiblingIndex(pattern_1._0, pattern_2);
  }
}

var NthChildPattern = {
  t_encode: t_encode,
  t_decode: t_decode,
  initWithTwoIndexes: initWithTwoIndexes,
  updateWithAdditionalSiblingIndex: updateWithAdditionalSiblingIndex,
  merge: merge
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "tagName",
                Decco.optionToJson(Decco.stringToJson, v.tagName)
              ],
              [
                "classNames",
                Decco.arrayToJson(Decco.stringToJson, v.classNames)
              ],
              [
                "attributes",
                Decco.arrayToJson(Decco.stringToJson, v.attributes)
              ],
              [
                "nthChildPattern",
                t_encode(v.nthChildPattern)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var tagName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tagName"), null));
  if (tagName.TAG === /* Ok */0) {
    var classNames = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "classNames"), null));
    if (classNames.TAG === /* Ok */0) {
      var attributes = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "attributes"), null));
      if (attributes.TAG === /* Ok */0) {
        var nthChildPattern = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "nthChildPattern"), null));
        if (nthChildPattern.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    tagName: tagName._0,
                    classNames: classNames._0,
                    attributes: attributes._0,
                    nthChildPattern: nthChildPattern._0
                  }
                };
        }
        var e = nthChildPattern._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".nthChildPattern" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = attributes._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".attributes" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = classNames._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".classNames" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = tagName._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".tagName" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function fromNode(node) {
  return {
          tagName: node.tagName,
          classNames: node.classNames,
          attributes: nodeAttributesForPattern(node),
          nthChildPattern: {
            TAG: /* SampleSizeOne */0,
            _0: node.index
          }
        };
}

function isEqualDuringProcessing(looseMatch_1, looseMatch_2) {
  if (Caml_obj.caml_equal(looseMatch_1.tagName, looseMatch_2.tagName) && Caml_obj.caml_equal(looseMatch_1.classNames, looseMatch_2.classNames)) {
    return Caml_obj.caml_equal(looseMatch_1.attributes, looseMatch_2.attributes);
  } else {
    return false;
  }
}

function mergeIdenticalLooseMatchesToUpdateNthChildPattern(looseMatch_1, param) {
  return {
          tagName: looseMatch_1.tagName,
          classNames: looseMatch_1.classNames,
          attributes: looseMatch_1.attributes,
          nthChildPattern: merge(looseMatch_1.nthChildPattern, param.nthChildPattern)
        };
}

function toCssSelector(exampleSelectorNode, param) {
  var nthChildPattern = param.nthChildPattern;
  var tmp;
  if (typeof nthChildPattern === "number") {
    tmp = "";
  } else if (nthChildPattern.TAG === /* SampleSizeOne */0) {
    var n = nthChildPattern._0;
    tmp = n !== undefined ? ":nth-child(" + (String(n) + ")") : "";
  } else {
    tmp = ":nth-child(" + (String(nthChildPattern._0) + ("n+" + (String(nthChildPattern._1) + ")")));
  }
  return OptionUtils$SmartcutsMacros.withDefault("*", param.tagName) + (Belt_Array.map(param.classNames, (function (className) {
                    return "." + window.CSS.escape(className);
                  })).join("") + (Belt_Array.map(param.attributes, (function (attrName) {
                      var arg = Belt_Option.map(Belt_Array.getBy(exampleSelectorNode.attributes, (function (param) {
                                  return param[0] === attrName;
                                })), (function (param) {
                              var attrVal = param[1];
                              if (attrVal.trim() === "") {
                                return "";
                              } else {
                                return "=" + window.CSS.escape(attrVal);
                              }
                            }));
                      return "[" + (window.CSS.escape(attrName) + ((function (param) {
                                      return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                                    })("") + "]"));
                    })).join("") + tmp));
}

function toSelectorTreeNode(exampleSelectorNode, param) {
  var attributes = param.attributes;
  return {
          id: undefined,
          tagName: param.tagName,
          classNames: param.classNames,
          attributes: Belt_Array.keep(exampleSelectorNode.attributes, (function (param) {
                  return $$Array.mem(param[0], attributes);
                })),
          index: undefined,
          innerText: /* Ignored */0,
          isScrollable: undefined,
          attributeBlacklist: []
        };
}

var LooseMatch = {
  NthChildPattern: NthChildPattern,
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  fromNode: fromNode,
  isEqualDuringProcessing: isEqualDuringProcessing,
  mergeIdenticalLooseMatchesToUpdateNthChildPattern: mergeIdenticalLooseMatchesToUpdateNthChildPattern,
  toCssSelector: toCssSelector,
  toSelectorTreeNode: toSelectorTreeNode
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.optionToJson(Decco.stringToJson, v.id)
              ],
              [
                "tagName",
                Decco.optionToJson(Decco.stringToJson, v.tagName)
              ],
              [
                "classNames",
                Decco.arrayToJson(Decco.stringToJson, v.classNames)
              ],
              [
                "attributes",
                Decco.arrayToJson(Decco.stringToJson, v.attributes)
              ],
              [
                "index",
                Decco.optionToJson(Decco.intToJson, v.index)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var tagName = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tagName"), null));
    if (tagName.TAG === /* Ok */0) {
      var classNames = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "classNames"), null));
      if (classNames.TAG === /* Ok */0) {
        var attributes = Decco.arrayFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "attributes"), null));
        if (attributes.TAG === /* Ok */0) {
          var index = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "index"), null));
          if (index.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      id: id._0,
                      tagName: tagName._0,
                      classNames: classNames._0,
                      attributes: attributes._0,
                      index: index._0
                    }
                  };
          }
          var e = index._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".index" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = attributes._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".attributes" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = classNames._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".classNames" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = tagName._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".tagName" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function fromNode$1(node) {
  return {
          id: OptionUtils$SmartcutsMacros.andThen((function (id) {
                  if (RandomCss$SmartcutsMacros.isGeneratedId(id)) {
                    return ;
                  } else {
                    return id;
                  }
                }), node.id),
          tagName: node.tagName,
          classNames: node.classNames,
          attributes: nodeAttributesForPattern(node),
          index: node.index
        };
}

function fromElement(element) {
  var partial_arg = window.location.origin;
  var arg = ListUtils$SmartcutsMacros.last(Belt_List.map(Selector$SmartcutsMacros.forDomElement(element), (function (param) {
              return Selector$SmartcutsMacros.pruneSelectorTreeNodeUsingOriginBlacklist(partial_arg, param);
            })));
  return fromNode$1((function (param) {
                  return OptionUtils$SmartcutsMacros.getExn(param, arg);
                })("Expect non-empty selector"));
}

function doesMatchLooseMatch(looseMatch, exactMatch) {
  if (Caml_obj.caml_equal(looseMatch.tagName, exactMatch.tagName) && Caml_obj.caml_equal(looseMatch.classNames, exactMatch.classNames)) {
    return Caml_obj.caml_equal(looseMatch.attributes, exactMatch.attributes);
  } else {
    return false;
  }
}

function doesMatchElement(element, indexBufferOpt, exactMatch) {
  var indexBuffer = indexBufferOpt !== undefined ? indexBufferOpt : 0;
  var exactMatch_2 = fromElement(element);
  var isEquivalentToExactMatch = Caml_obj.caml_equal(exactMatch, exactMatch_2);
  if (isEquivalentToExactMatch) {
    return isEquivalentToExactMatch;
  }
  var match = exactMatch.index;
  var match$1 = exactMatch_2.index;
  if (match !== undefined && match$1 !== undefined) {
    if (Math.abs(match - match$1 | 0) <= indexBuffer && Caml_obj.caml_equal({
            id: exactMatch.id,
            tagName: exactMatch.tagName,
            classNames: exactMatch.classNames,
            attributes: exactMatch.attributes,
            index: undefined
          }, {
            id: exactMatch_2.id,
            tagName: exactMatch_2.tagName,
            classNames: exactMatch_2.classNames,
            attributes: exactMatch_2.attributes,
            index: undefined
          })) {
      return true;
    } else {
      return false;
    }
  } else {
    return isEquivalentToExactMatch;
  }
}

function maybeLooseMatchWhenPairedWithExactMatch(exactMatch_2, exactMatch) {
  var match = exactMatch.tagName;
  var match$1 = exactMatch_2.tagName;
  if (match !== undefined && match === "a" && match$1 === "a") {
    return ;
  }
  if (Caml_obj.caml_equal(exactMatch.tagName, exactMatch_2.tagName) && Caml_obj.caml_equal(exactMatch.classNames, exactMatch_2.classNames) && Caml_obj.caml_equal(exactMatch.attributes, exactMatch_2.attributes) && !(Caml_obj.caml_equal(exactMatch.id, exactMatch_2.id) && Caml_obj.caml_equal(exactMatch.index, exactMatch_2.index))) {
    return {
            tagName: exactMatch.tagName,
            classNames: exactMatch.classNames,
            attributes: exactMatch.attributes,
            nthChildPattern: initWithTwoIndexes(exactMatch.index, exactMatch_2.index)
          };
  }
  
}

function couldBeLooseMatchWithNode(node, exactMatchPattern) {
  var match = exactMatchPattern.tagName;
  var match$1 = node.tagName;
  if (match !== undefined && match === "a" && match$1 === "a") {
    return false;
  }
  if (Caml_obj.caml_equal(exactMatchPattern.tagName, node.tagName) && Caml_obj.caml_equal(exactMatchPattern.classNames, node.classNames) && $$Array.for_all((function (key) {
            return $$Array.exists((function (param) {
                          return key === param[0];
                        }), node.attributes);
          }), exactMatchPattern.attributes)) {
    return !(Caml_obj.caml_equal(exactMatchPattern.id, node.id) && Caml_obj.caml_equal(exactMatchPattern.index, node.index));
  } else {
    return false;
  }
}

function toCssSelector$1(exampleSelectorNode, param) {
  var arg = OptionUtils$SmartcutsMacros.map(param.id, (function (s) {
          return "#" + window.CSS.escape(s);
        }));
  var arg$1 = OptionUtils$SmartcutsMacros.map(param.index, (function (i) {
          return ":nth-child(" + (String(i) + ")");
        }));
  return OptionUtils$SmartcutsMacros.withDefault("*", param.tagName) + ((function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
              })("") + (Belt_Array.map(param.classNames, (function (className) {
                      return "." + window.CSS.escape(className);
                    })).join("") + (Belt_Array.map(param.attributes, (function (attrName) {
                        var arg = Belt_Option.map(Belt_Array.getBy(exampleSelectorNode.attributes, (function (param) {
                                    return param[0] === attrName;
                                  })), (function (param) {
                                var attrVal = param[1];
                                if (attrVal.trim() === "") {
                                  return "";
                                } else {
                                  return "=" + StringUtils$SmartcutsMacros.quote(window.CSS.escape(attrVal));
                                }
                              }));
                        return "[" + (window.CSS.escape(attrName) + ((function (param) {
                                        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                                      })("") + "]"));
                      })).join("") + (function (param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
                  })(""))));
}

function toSelectorTreeNode$1(exampleSelectorNode, param) {
  var attributes = param.attributes;
  return {
          id: param.id,
          tagName: param.tagName,
          classNames: param.classNames,
          attributes: Belt_Array.keep(exampleSelectorNode.attributes, (function (param) {
                  return $$Array.mem(param[0], attributes);
                })),
          index: param.index,
          innerText: /* Ignored */0,
          isScrollable: undefined,
          attributeBlacklist: []
        };
}

var ExactMatch = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  fromNode: fromNode$1,
  fromElement: fromElement,
  doesMatchLooseMatch: doesMatchLooseMatch,
  doesMatchElement: doesMatchElement,
  maybeLooseMatchWhenPairedWithExactMatch: maybeLooseMatchWhenPairedWithExactMatch,
  couldBeLooseMatchWithNode: couldBeLooseMatchWithNode,
  toCssSelector: toCssSelector$1,
  toSelectorTreeNode: toSelectorTreeNode$1
};

function t_encode$3(v) {
  if (v.TAG === /* ExactMatch */0) {
    return [
            "ExactMatch",
            t_encode$2(v._0)
          ];
  } else {
    return [
            "LooseMatch",
            t_encode$1(v._0)
          ];
  }
}

function t_decode$3(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ExactMatch" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = t_decode$2(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ExactMatch */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "LooseMatch" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = t_decode$1(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* LooseMatch */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function exactMatchFromNode(node) {
  return {
          TAG: /* ExactMatch */0,
          _0: fromNode$1(node)
        };
}

function looseMatchFromNode(node) {
  return {
          TAG: /* LooseMatch */1,
          _0: fromNode(node)
        };
}

function compareNodeAttributes(node_1, node_2) {
  var match = node_1.tagName;
  var match$1 = node_2.tagName;
  if (match !== undefined && match === "a" && match$1 === "a") {
    return Caml_obj.caml_equal(Belt_Array.keep(node_1.attributes, (function (param) {
                      return param[0] !== "href";
                    })), Belt_Array.keep(node_2.attributes, (function (param) {
                      return param[0] !== "href";
                    })));
  }
  return Caml_obj.caml_equal(node_1.attributes, node_2.attributes);
}

function maybeFromPairOfSelectorTreeNodes(node_1, node_2) {
  var match = node_1.tagName;
  var match$1 = node_2.tagName;
  if (match !== undefined && match$1 !== undefined && match === match$1 && Caml_obj.caml_equal(node_1.classNames, node_2.classNames) && compareNodeAttributes(node_1, node_2)) {
    if (Caml_obj.caml_equal(node_1.id, node_2.id) && Caml_obj.caml_equal(node_1.index, node_2.index)) {
      return {
              TAG: /* One */0,
              _0: {
                TAG: /* ExactMatch */0,
                _0: fromNode$1(node_1)
              }
            };
    } else if (match === "a" && match$1 === "a") {
      return {
              TAG: /* Two */1,
              _0: {
                TAG: /* ExactMatch */0,
                _0: fromNode$1(node_1)
              },
              _1: {
                TAG: /* ExactMatch */0,
                _0: fromNode$1(node_2)
              }
            };
    } else {
      return {
              TAG: /* One */0,
              _0: {
                TAG: /* LooseMatch */1,
                _0: fromNode(node_1)
              }
            };
    }
  } else {
    return {
            TAG: /* Two */1,
            _0: {
              TAG: /* ExactMatch */0,
              _0: fromNode$1(node_1)
            },
            _1: {
              TAG: /* ExactMatch */0,
              _0: fromNode$1(node_2)
            }
          };
  }
}

function isLooseMatch(treeNodePattern) {
  if (treeNodePattern.TAG === /* ExactMatch */0) {
    return false;
  } else {
    return true;
  }
}

function exactMatchGet(treeNodePattern) {
  if (treeNodePattern.TAG === /* ExactMatch */0) {
    return treeNodePattern._0;
  }
  
}

var TreeNodePattern = {
  nodeAttributesForPattern: nodeAttributesForPattern,
  LooseMatch: LooseMatch,
  ExactMatch: ExactMatch,
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  exactMatchFromNode: exactMatchFromNode,
  looseMatchFromNode: looseMatchFromNode,
  compareNodeAttributes: compareNodeAttributes,
  maybeFromPairOfSelectorTreeNodes: maybeFromPairOfSelectorTreeNodes,
  isLooseMatch: isLooseMatch,
  exactMatchGet: exactMatchGet
};

function t_encode$4(v) {
  return Decco.listToJson(t_encode$3, v);
}

function t_decode$4(v) {
  return Decco.listFromJson(t_decode$3, v);
}

function doesMatchElement$1(indexBufferOpt, element, pattern) {
  var indexBuffer = indexBufferOpt !== undefined ? indexBufferOpt : 0;
  var _element = element;
  var _index = 0;
  while(true) {
    var index = _index;
    var element$1 = _element;
    var match = Belt_List.get(pattern, index);
    var doesMatchThisLevel = match !== undefined ? (
        match.TAG === /* ExactMatch */0 ? doesMatchElement(element$1, indexBuffer, match._0) : doesMatchLooseMatch(match._0, fromElement(element$1))
      ) : true;
    var parentElement = element$1.parentElement;
    if (parentElement == null) {
      return doesMatchThisLevel;
    }
    if (!doesMatchThisLevel) {
      return doesMatchThisLevel;
    }
    _index = index + 1 | 0;
    _element = parentElement;
    continue ;
  };
}

function truncateToTopMostRepeatingElement(pattern) {
  var treeNodePatternsFromRootToLeaf = Belt_Array.reverse($$Array.of_list(pattern));
  var maybeIndexOfFirstLooseMatchPattern = Belt_Array.getIndexBy(treeNodePatternsFromRootToLeaf, isLooseMatch);
  var arg = OptionUtils$SmartcutsMacros.map(maybeIndexOfFirstLooseMatchPattern, (function (i) {
          return i + 1 | 0;
        }));
  var lengthToSlice = (function (param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
      })(treeNodePatternsFromRootToLeaf.length);
  return $$Array.to_list(Belt_Array.reverse(Belt_Array.slice(treeNodePatternsFromRootToLeaf, 0, lengthToSlice)));
}

function getSelectorToParentOfFirstLooseMatch(selectorOfAMemberElement, pattern) {
  var treeNodePatternsFromRootToLeaf = Belt_Array.reverse($$Array.of_list(pattern));
  var maybeIndexOfFirstLooseMatchPattern = Belt_Array.getIndexBy(treeNodePatternsFromRootToLeaf, isLooseMatch);
  var arg = OptionUtils$SmartcutsMacros.map(maybeIndexOfFirstLooseMatchPattern, (function (index) {
          var arg = Belt_List.take(selectorOfAMemberElement, index);
          var param = "Expected selector to have length >= " + String(index);
          return OptionUtils$SmartcutsMacros.getExn(param, arg);
        }));
  return OptionUtils$SmartcutsMacros.withDefault(selectorOfAMemberElement, arg);
}

function keepOnlyFirstContiguousExactMatches(pattern) {
  var treeNodePatternsFromRootToLeaf = Belt_Array.reverse($$Array.of_list(pattern));
  var maybeIndexOfFirstLooseMatchPattern = Belt_Array.getIndexBy(treeNodePatternsFromRootToLeaf, isLooseMatch);
  var arg = OptionUtils$SmartcutsMacros.map(maybeIndexOfFirstLooseMatchPattern, (function (index) {
          return Belt_Array.slice(treeNodePatternsFromRootToLeaf, 0, index);
        }));
  return $$Array.to_list((function (param) {
                  return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                })(treeNodePatternsFromRootToLeaf));
}

function updateFirstTreeNodePattern(f, selectorPattern) {
  return ListUtils$SmartcutsMacros.updateAt(0, f, selectorPattern);
}

var SelectorPattern = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  empty: /* [] */0,
  toPrintable: $$Array.of_list,
  doesMatchElement: doesMatchElement$1,
  truncateToTopMostRepeatingElement: truncateToTopMostRepeatingElement,
  getSelectorToParentOfFirstLooseMatch: getSelectorToParentOfFirstLooseMatch,
  keepOnlyFirstContiguousExactMatches: keepOnlyFirstContiguousExactMatches,
  updateFirstTreeNodePattern: updateFirstTreeNodePattern
};

function mapPattern(f, param) {
  return [
          Curry._1(f, param[0]),
          param[1]
        ];
}

function truncatePatternToTopMostRepeatingElement(group) {
  return mapPattern(truncateToTopMostRepeatingElement, group);
}

function toCssSelector$2(param) {
  var treeNodePatternsFromRootToLeaf = Belt_Array.reverse($$Array.of_list(param[0]));
  var exampleSelector = Caml_array.get(param[1], 0)[1];
  return Belt_Array.mapWithIndex(treeNodePatternsFromRootToLeaf, (function (treeLevel, treeNodePattern) {
                  var exampleSelectorNode = Belt_List.getExn(exampleSelector, treeLevel);
                  if (treeNodePattern.TAG === /* ExactMatch */0) {
                    return toCssSelector$1(exampleSelectorNode, treeNodePattern._0);
                  } else {
                    return toCssSelector(exampleSelectorNode, treeNodePattern._0);
                  }
                })).join(" > ");
}

function toSelector(param) {
  var treeNodePatternsFromRootToLeaf = Belt_Array.reverse($$Array.of_list(param[0]));
  var exampleSelector = Caml_array.get(param[1], 0)[1];
  return $$Array.to_list(Belt_Array.mapWithIndex(treeNodePatternsFromRootToLeaf, (function (treeLevel, treeNodePattern) {
                    var exampleSelectorNode = Belt_List.getExn(exampleSelector, treeLevel);
                    if (treeNodePattern.TAG === /* ExactMatch */0) {
                      return toSelectorTreeNode$1(exampleSelectorNode, treeNodePattern._0);
                    } else {
                      return toSelectorTreeNode(exampleSelectorNode, treeNodePattern._0);
                    }
                  })));
}

var TopologyGroup = {
  mapPattern: mapPattern,
  truncatePatternToTopMostRepeatingElement: truncatePatternToTopMostRepeatingElement,
  toCssSelector: toCssSelector$2,
  toSelector: toSelector
};

function getFirstGroup(grouper) {
  return Belt_Array.get(grouper, 0);
}

function toPrintable(grouper) {
  return $$Array.map((function (param) {
                return [
                        $$Array.of_list(param[0]),
                        $$Array.map((function (param) {
                                return [
                                        param[0],
                                        $$Array.of_list(param[1])
                                      ];
                              }), param[1])
                      ];
              }), grouper);
}

var empty = [];

function make(origin, elements) {
  var elementSelectorPairs = $$Array.map((function (element) {
          return [
                  element,
                  Belt_List.map(Selector$SmartcutsMacros.forDomElement(element), (function (param) {
                          return Selector$SmartcutsMacros.pruneSelectorTreeNodeUsingOriginBlacklist(origin, param);
                        }))
                ];
        }), elements);
  return [[
            /* [] */0,
            elementSelectorPairs
          ]];
}

function stillNeedsProcessing(grouper) {
  return Belt_Array.some(grouper, (function (param) {
                var selectorPattern = param[0];
                return Belt_Array.some(param[1], (function (param) {
                              return List.length(param[1]) > List.length(selectorPattern);
                            }));
              }));
}

function mergeElementSelectorPairAndPatternIn(elementSelectorPair, patternToMergeIn, grouper) {
  var match = Belt_Array.reduce(grouper, [
        false,
        []
      ], (function (param, param$1) {
          var elementSelectorPairs = param$1[1];
          var existingSelectorPattern = param$1[0];
          var nextGrouper = param[1];
          if (param[0]) {
            return [
                    true,
                    $$Array.append(nextGrouper, [[
                            existingSelectorPattern,
                            elementSelectorPairs
                          ]])
                  ];
          }
          if (!patternToMergeIn) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected empty selector pattern");
          }
          var exactMatch = patternToMergeIn.hd;
          if (!existingSelectorPattern) {
            return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected empty selector pattern");
          }
          if (Caml_obj.caml_notequal(patternToMergeIn.tl, existingSelectorPattern.tl)) {
            return [
                    false,
                    $$Array.append(nextGrouper, [[
                            existingSelectorPattern,
                            elementSelectorPairs
                          ]])
                  ];
          }
          if (exactMatch.TAG === /* ExactMatch */0) {
            var looseMatch = existingSelectorPattern.hd;
            var exactMatch$1 = exactMatch._0;
            if (looseMatch.TAG === /* ExactMatch */0) {
              var exactMatch_2 = looseMatch._0;
              if (Caml_obj.caml_equal(exactMatch$1, exactMatch_2)) {
                return [
                        true,
                        $$Array.append(nextGrouper, [[
                                existingSelectorPattern,
                                Belt_Array.some(elementSelectorPairs, (function (param) {
                                        return param[0] === elementSelectorPair[0];
                                      })) ? elementSelectorPairs : $$Array.append(elementSelectorPairs, [elementSelectorPair])
                              ]])
                      ];
              }
              var looseMatch$1 = maybeLooseMatchWhenPairedWithExactMatch(exactMatch_2, exactMatch$1);
              if (looseMatch$1 !== undefined) {
                return [
                        true,
                        $$Array.append(nextGrouper, [[
                                {
                                  hd: {
                                    TAG: /* LooseMatch */1,
                                    _0: looseMatch$1
                                  },
                                  tl: existingSelectorPattern.tl
                                },
                                Belt_Array.some(elementSelectorPairs, (function (param) {
                                        return param[0] === elementSelectorPair[0];
                                      })) ? elementSelectorPairs : $$Array.append(elementSelectorPairs, [elementSelectorPair])
                              ]])
                      ];
              } else {
                return [
                        false,
                        $$Array.append(nextGrouper, [[
                                existingSelectorPattern,
                                elementSelectorPairs
                              ]])
                      ];
              }
            }
            var looseMatch$2 = looseMatch._0;
            if (doesMatchLooseMatch(looseMatch$2, exactMatch$1)) {
              return [
                      true,
                      $$Array.append(nextGrouper, [[
                              updateFirstTreeNodePattern((function (param) {
                                      return {
                                              TAG: /* LooseMatch */1,
                                              _0: {
                                                tagName: looseMatch$2.tagName,
                                                classNames: looseMatch$2.classNames,
                                                attributes: looseMatch$2.attributes,
                                                nthChildPattern: updateWithAdditionalSiblingIndex(exactMatch$1.index, looseMatch$2.nthChildPattern)
                                              }
                                            };
                                    }), existingSelectorPattern),
                              Belt_Array.some(elementSelectorPairs, (function (param) {
                                      return param[0] === elementSelectorPair[0];
                                    })) ? elementSelectorPairs : $$Array.append(elementSelectorPairs, [elementSelectorPair])
                            ]])
                    ];
            } else {
              return [
                      false,
                      $$Array.append(nextGrouper, [[
                              existingSelectorPattern,
                              elementSelectorPairs
                            ]])
                    ];
            }
          }
          var exactMatch$2 = existingSelectorPattern.hd;
          var looseMatch$3 = exactMatch._0;
          if (exactMatch$2.TAG === /* ExactMatch */0) {
            var exactMatch$3 = exactMatch$2._0;
            if (doesMatchLooseMatch(looseMatch$3, exactMatch$3)) {
              return [
                      true,
                      $$Array.append(nextGrouper, [[
                              updateFirstTreeNodePattern((function (param) {
                                      return {
                                              TAG: /* LooseMatch */1,
                                              _0: {
                                                tagName: looseMatch$3.tagName,
                                                classNames: looseMatch$3.classNames,
                                                attributes: looseMatch$3.attributes,
                                                nthChildPattern: updateWithAdditionalSiblingIndex(exactMatch$3.index, looseMatch$3.nthChildPattern)
                                              }
                                            };
                                    }), patternToMergeIn),
                              Belt_Array.some(elementSelectorPairs, (function (param) {
                                      return param[0] === elementSelectorPair[0];
                                    })) ? elementSelectorPairs : $$Array.append(elementSelectorPairs, [elementSelectorPair])
                            ]])
                    ];
            } else {
              return [
                      false,
                      $$Array.append(nextGrouper, [[
                              existingSelectorPattern,
                              elementSelectorPairs
                            ]])
                    ];
            }
          }
          var looseMatch_2 = exactMatch$2._0;
          if (isEqualDuringProcessing(looseMatch$3, looseMatch_2)) {
            return [
                    true,
                    $$Array.append(nextGrouper, [[
                            updateFirstTreeNodePattern((function (param) {
                                    return {
                                            TAG: /* LooseMatch */1,
                                            _0: mergeIdenticalLooseMatchesToUpdateNthChildPattern(looseMatch_2, looseMatch$3)
                                          };
                                  }), existingSelectorPattern),
                            Belt_Array.some(elementSelectorPairs, (function (param) {
                                    return param[0] === elementSelectorPair[0];
                                  })) ? elementSelectorPairs : $$Array.append(elementSelectorPairs, [elementSelectorPair])
                          ]])
                  ];
          } else {
            return [
                    false,
                    $$Array.append(nextGrouper, [[
                            existingSelectorPattern,
                            elementSelectorPairs
                          ]])
                  ];
          }
        }));
  var nextGrouper = match[1];
  if (match[0]) {
    return nextGrouper;
  } else {
    return $$Array.append(nextGrouper, [[
                  patternToMergeIn,
                  [elementSelectorPair]
                ]]);
  }
}

function nextIteration(treeWalker) {
  return Belt_Array.reduce(treeWalker, [], (function (nextGrouper, param) {
                var elementSelectorPairs = param[1];
                var selectorPattern = param[0];
                var levelToInspect = List.length(selectorPattern);
                if (elementSelectorPairs.length !== 1) {
                  return Belt_Array.reduce(ArrayUtils$SmartcutsMacros.windowMap2((function (elementSelectorPair_1, elementSelectorPair_2) {
                                    return [
                                            elementSelectorPair_1,
                                            elementSelectorPair_2
                                          ];
                                  }), elementSelectorPairs), nextGrouper, (function (nextGrouper_2, param) {
                                var elementSelectorPair_2 = param[1];
                                var elementSelectorPair_1 = param[0];
                                var match = Belt_List.get(elementSelectorPair_1[1], levelToInspect);
                                var match$1 = Belt_List.get(elementSelectorPair_2[1], levelToInspect);
                                if (match === undefined) {
                                  if (match$1 !== undefined) {
                                    return mergeElementSelectorPairAndPatternIn(elementSelectorPair_2, {
                                                hd: {
                                                  TAG: /* ExactMatch */0,
                                                  _0: fromNode$1(match$1)
                                                },
                                                tl: selectorPattern
                                              }, mergeElementSelectorPairAndPatternIn(elementSelectorPair_1, selectorPattern, nextGrouper_2));
                                  } else {
                                    return mergeElementSelectorPairAndPatternIn(elementSelectorPair_2, selectorPattern, mergeElementSelectorPairAndPatternIn(elementSelectorPair_1, selectorPattern, nextGrouper_2));
                                  }
                                }
                                if (match$1 === undefined) {
                                  return mergeElementSelectorPairAndPatternIn(elementSelectorPair_2, selectorPattern, mergeElementSelectorPairAndPatternIn(elementSelectorPair_1, {
                                                  hd: {
                                                    TAG: /* ExactMatch */0,
                                                    _0: fromNode$1(match)
                                                  },
                                                  tl: selectorPattern
                                                }, nextGrouper_2));
                                }
                                var match$2 = maybeFromPairOfSelectorTreeNodes(match, match$1);
                                if (match$2.TAG !== /* One */0) {
                                  return mergeElementSelectorPairAndPatternIn(elementSelectorPair_2, {
                                              hd: match$2._1,
                                              tl: selectorPattern
                                            }, mergeElementSelectorPairAndPatternIn(elementSelectorPair_1, {
                                                  hd: match$2._0,
                                                  tl: selectorPattern
                                                }, nextGrouper_2));
                                }
                                var treeNodePattern = match$2._0;
                                return mergeElementSelectorPairAndPatternIn(elementSelectorPair_2, {
                                            hd: treeNodePattern,
                                            tl: selectorPattern
                                          }, mergeElementSelectorPairAndPatternIn(elementSelectorPair_1, {
                                                hd: treeNodePattern,
                                                tl: selectorPattern
                                              }, nextGrouper_2));
                              }));
                }
                var elementSelectorPair = Caml_array.get(elementSelectorPairs, 0);
                var node = Belt_List.get(elementSelectorPair[1], levelToInspect);
                if (node !== undefined) {
                  return mergeElementSelectorPairAndPatternIn(elementSelectorPair, {
                              hd: {
                                TAG: /* ExactMatch */0,
                                _0: fromNode$1(node)
                              },
                              tl: selectorPattern
                            }, nextGrouper);
                } else {
                  return $$Array.append(nextGrouper, [[
                                selectorPattern,
                                elementSelectorPairs
                              ]]);
                }
              }));
}

function doAllGroupsShareSameAncestorPatternOfExactMatches(grouper) {
  var ancestorsPatternPerGroup = Belt_Array.keepMap(grouper, (function (param) {
          return Belt_List.tail(param[0]);
        }));
  var firstAncestorsPattern = Belt_Array.get(ancestorsPatternPerGroup, 0);
  if (firstAncestorsPattern !== undefined && firstAncestorsPattern && !Belt_List.some(firstAncestorsPattern, isLooseMatch)) {
    return Belt_Array.every(Belt_Array.sliceToEnd(ancestorsPatternPerGroup, 1), (function (otherPattern) {
                  return Caml_obj.caml_equal(otherPattern, firstAncestorsPattern);
                }));
  } else {
    return false;
  }
}

function doAllGroupsEndWithAnchor(grouper) {
  var leafPatternPerGroup = Belt_Array.keepMap(grouper, (function (param) {
          return Belt_List.get(param[0], 0);
        }));
  return Belt_Array.every(leafPatternPerGroup, (function (pattern) {
                if (pattern.TAG !== /* ExactMatch */0) {
                  return false;
                }
                var match = pattern._0.tagName;
                if (match === "a") {
                  return true;
                } else {
                  return false;
                }
              }));
}

function $$process(_grouper) {
  while(true) {
    var grouper = _grouper;
    if (!stillNeedsProcessing(grouper)) {
      if (doAllGroupsShareSameAncestorPatternOfExactMatches(grouper) && doAllGroupsEndWithAnchor(grouper)) {
        return Belt_Array.reduce(grouper, empty, (function (newGrouper, param) {
                      var elementSelectorPairs = param[1];
                      var pattern = param[0];
                      if (!pattern) {
                        return newGrouper;
                      }
                      var match = pattern.hd;
                      if (match.TAG !== /* ExactMatch */0) {
                        return newGrouper;
                      }
                      var ancestorPattern = pattern.tl;
                      var match$1 = match._0;
                      var index = match$1.index;
                      var attributes = match$1.attributes;
                      var classNames = match$1.classNames;
                      var tagName = match$1.tagName;
                      var match$2 = Belt_Array.get(newGrouper, 0);
                      if (match$2 !== undefined) {
                        var match$3 = match$2[0];
                        if (!match$3) {
                          return newGrouper;
                        }
                        var wipLooseMatch = match$3.hd;
                        if (wipLooseMatch.TAG === /* ExactMatch */0) {
                          return newGrouper;
                        }
                        var looseMatch_nthChildPattern = {
                          TAG: /* SampleSizeOne */0,
                          _0: index
                        };
                        var looseMatch = {
                          tagName: tagName,
                          classNames: classNames,
                          attributes: attributes,
                          nthChildPattern: looseMatch_nthChildPattern
                        };
                        var newLooseMatch = mergeIdenticalLooseMatchesToUpdateNthChildPattern(wipLooseMatch._0, looseMatch);
                        return [[
                                  {
                                    hd: {
                                      TAG: /* LooseMatch */1,
                                      _0: newLooseMatch
                                    },
                                    tl: ancestorPattern
                                  },
                                  $$Array.append(match$2[1], elementSelectorPairs)
                                ]];
                      }
                      var looseMatch_nthChildPattern$1 = {
                        TAG: /* SampleSizeOne */0,
                        _0: index
                      };
                      var looseMatch$1 = {
                        tagName: tagName,
                        classNames: classNames,
                        attributes: attributes,
                        nthChildPattern: looseMatch_nthChildPattern$1
                      };
                      return [[
                                {
                                  hd: {
                                    TAG: /* LooseMatch */1,
                                    _0: looseMatch$1
                                  },
                                  tl: ancestorPattern
                                },
                                elementSelectorPairs
                              ]];
                    }));
      } else {
        return grouper;
      }
    }
    _grouper = nextIteration(grouper);
    continue ;
  };
}

var ElementGrouper = {
  TreeNodePattern: TreeNodePattern,
  SelectorPattern: SelectorPattern,
  TopologyGroup: TopologyGroup,
  getFirstGroup: getFirstGroup,
  toPrintable: toPrintable,
  empty: empty,
  make: make,
  doAllGroupsShareSameAncestorPatternOfExactMatches: doAllGroupsShareSameAncestorPatternOfExactMatches,
  doAllGroupsEndWithAnchor: doAllGroupsEndWithAnchor,
  $$process: $$process
};

function group(origin, elements) {
  return $$process(make(origin, elements));
}

exports.ElementGrouper = ElementGrouper;
exports.group = group;
/* Util-SmartcutsMacros Not a pure module */
